export const UPDATE_RESULTS_QSEB_REQUEST = 'UPDATE_RESULTS_QSEB_REQUEST';

export const updateResultsQsebRequest = ( results ) => ({
    type: UPDATE_RESULTS_QSEB_REQUEST,
    payload: {
        results,
    }
});
